// Km/día que da de verdad un pack de km con este vehículo, si no son los del nombre del pack: un pack
// nunca da menos de lo que ya incluye el vehículo (backend/catalog.py, pack_km_per_day). null si el
// pack ya da más (o es ilimitado) y su nombre basta.
export function kmConVehiculo(producto, kmVehiculo) {
  const daily = producto?.meta?.daily_km;
  const base = Number(kmVehiculo);
  if (daily == null || !Number.isFinite(base)) return null;
  return base > Number(daily) ? base : null;
}
